import { useEffect, useState, createRef } from 'react'
import styled from 'styled-components'
import { FiHelpCircle } from 'react-icons/fi'
import { useEffectOnce } from 'usehooks-ts'
import { IoClose } from 'react-icons/io5'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css' // optional
import './styles.css'

const ExplainMe = ({
  term,
  image,
  video,
  audio,
  maxWidth,
  position,
  caption,
  source,
  appRef,
}: {
  term: string
  image?: string
  video?: string
  audio?: string
  maxWidth?: number
  position?: string
  caption?: string
  source?: string
  appRef?: any
}) => {
  const [isInteractive, setIsInteractive] = useState(true)
  const [initialLoad, setInitialLoad] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const videoRef = createRef<HTMLVideoElement>()
  const audioRef = createRef<HTMLAudioElement>()
  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
  }

  useEffectOnce(() => {
    setTimeout(() => {
      setInitialLoad(true)
    }, 3000)
  })

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const startVideo = () => {
    const videoElement = videoRef.current as HTMLVideoElement
    // console.log('videoElement: ' + videoElement)
    setTimeout(() => {
      videoElement.currentTime = 0 //start from begining
      videoElement.play()
    }, 1)
  }

  const startAudio = () => {
    const audioElement = audioRef.current as HTMLAudioElement
    // console.log('audioElement: ' + audioElement)
    setTimeout(() => {
      audioElement.currentTime = 0 //start from begining
      audioElement.play()
    }, 1)
  }

  const makeCloseable = () => {
    setIsInteractive(false)
  }

  return (
    <Tippy
      content={
        <>
          {image && <img src={image} alt={source} />}
          {video && (
            <video
              autoPlay={initialLoad ? true : false}
              playsInline
              loop
              ref={videoRef}
            >
              <source src={video} type='video/mp4' />
            </video>
          )}
          {audio && (
            <audio
              controls
              autoPlay={initialLoad ? true : false}
              ref={audioRef}
            >
              <source src={audio} type='audio/mpeg' />
            </audio>
          )}
          {caption && <div className='caption'>{caption}</div>}
          {source && <div className='source'>{source}</div>}
          <div className='closer' onMouseEnter={() => makeCloseable()}>
            <IoClose />
          </div>
        </>
      }
      trigger={'click'}
      placement={position === 'top' ? 'top' : isMobile ? 'bottom' : 'top'}
      maxWidth={maxWidth ? maxWidth : 250}
      theme={'quiz'}
      interactive={video || audio ? isInteractive : false}
      hideOnClick={true}
      arrow
      onShow={() => (video ? startVideo() : audio ? startAudio() : undefined)}
      onHide={() => setIsInteractive(true)}
      // appendTo={'parent'}
      appendTo={() => appRef.current}
      // appendTo={questionData.tooltipRef}
    >
      <Explainer>
        <FiHelpCircle />
        {term}
      </Explainer>
    </Tippy>
  )
}
const Explainer = styled.span`
  background-color: var(--yellow-main);
  padding: 0.2rem 0.6rem;
  border-radius: 0.3rem;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  display: inline;
  color: var(--text-explain);
  font-size: 1.5rem;
  font-weight: 400;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  &:hover {
    @media (hover: hover) {
      background-color: #c0ac4e;
    }
  }
  svg {
    margin-right: 0.2rem;
    top: -0.2rem;
    position: relative;
    width: 1.7rem;
    height: auto;
  }
`

export default ExplainMe
